// Mapa iconName (ver TourStep.iconName en TourContext.tsx) -> componente lucide-react. Archivo
// propio, separado de notificationIcons.tsx (dominios distintos, sin ciclo de vida compartido).
// Fallback a un ícono genérico si un step no define iconName -- permite poblar los ~33 steps de
// forma incremental, no todo-o-nada.
import {
  Home, Users, FileEdit, History, Truck, PackagePlus, MapPin, Wallet, PiggyBank,
  RefreshCw, Mail, DollarSign, LayoutDashboard, BarChart3, ShieldCheck, Briefcase,
  Settings, PercentCircle, FileWarning, Compass,
  CalendarClock, LifeBuoy, Plane, RotateCcw, Receipt, FileCheck2, Scale,
  type LucideIcon,
} from 'lucide-react';

export const TOUR_ICONS: Record<string, LucideIcon> = {
  Home, Users, FileEdit, History, Truck, PackagePlus, MapPin, Wallet, PiggyBank,
  RefreshCw, Mail, DollarSign, LayoutDashboard, BarChart3, ShieldCheck, Briefcase,
  Settings, PercentCircle, FileWarning, Compass,
  CalendarClock, LifeBuoy, Plane, RotateCcw, Receipt, FileCheck2, Scale,
};

export function getTourIcon(iconName?: string): LucideIcon {
  if (!iconName) return Compass;
  return TOUR_ICONS[iconName] || Compass;
}
